// extracted by mini-css-extract-plugin
export var error = "Textarea-module--error--RVU9o";
export var textAreaContainer = "Textarea-module--textAreaContainer--W7l7q";
export var textAreaField = "Textarea-module--textAreaField--Gzh-W";
export var textAreaLabel = "Textarea-module--textAreaLabel--D3f3l";
export var textAreaLabelMoved = "Textarea-module--textAreaLabelMoved--N3eSQ";
export var textAreaScrolled = "Textarea-module--textAreaScrolled--blEun";